module.exports = __webpack_public_path__ + "static/media/meal-sharing.76b0437a.PNG";